requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView.sectionId,
      enabled: window.xQuickView.enabled,
      buttonLabel: window.xQuickView.buttonLabel,
      show_atc_button: window.xQuickView.show_atc_button,
      show: false,
      loading: false,
      cachedResults: [],
      selected: false,
      addListener() {
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
        });
      },
      showBtn(enable, showATCButton, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },
      load(url, el) {
        let getVariant = el.getAttribute('data-variant');
        let urlProduct = getVariant?`${url}?variant=${getVariant}&section_id=${this.sectionId}`:`${url}?section_id=${this.sectionId}`;
        
        if (this.cachedResults[urlProduct]) {
          document.getElementById('quickview-product-content').innerHTML = this.cachedResults[urlProduct];
          return true;
        }

        this.loading = true;
        fetch(urlProduct)
          .then(reponse => {
            return reponse.text();
          })
          .then((response) => {            
            const parser = new DOMParser();
            const content = parser.parseFromString(response,'text/html')
                              .getElementById("quickview-product-content").innerHTML;
            document.getElementById('quickview-product-content').innerHTML = content;
            
            this.cachedResults[urlProduct] = content;
            
          })
          .finally(() => {
            this.loading = false;
          })

        return true;
      },
      open() {
        this.show = true;
        Alpine.store('xPopup').open = true;
        let product = document.querySelector("#quickview-product-content [x-customer-event-data]")?.getAttribute("x-customer-event-data");
        if(product) {
          const productJson = JSON.parse(product);
          window.selected_product_id = productJson.product.id;
        } else {
          setTimeout(()=>{
            let product = document.querySelector("#quickview-product-content [x-customer-event-data]")?.getAttribute("x-customer-event-data");
            if(product) {
              const productJson = JSON.parse(product);
              window.selected_product_id = productJson.product.id;
            }
          }, 1500);
        }
      },
      close() {
        this.show = false;
        Alpine.store('xPopup').open = false;
      },
      focusQuickView(quickView, btnClose) {
        if ( !this.selected ) { 
          Alpine.store('xFocusElement').trapFocus(quickView, btnClose);
        }
      },
      removeFocusQuickView() {
        if ( !this.selected ) { 
          const elementActive = document.getElementById("button_quickview");
          Alpine.store('xFocusElement').removeTrapFocus(elementActive);
        }
      }
    });
  });
});